'use client'

import cn from 'clsx'
import { useState } from 'react'
import { BottomPromo } from './bottom-promo'
import { PricingCard } from './card'
import s from './pricing.module.css'
import { Tabs } from './tabs'

const plans = [
  {
    _uid: 'e9b1e6f2-b960-4b7b-8e20-2a83a4d8ec25',
    name: 'Professional',
    monthly: { price: '$15/month', note: '' },
    yearly: { price: '$12/month', note: 'Billed anually as $144' },
    features: [
      {
        _uid: '9d3e5a6c-6d5c-4e01-8e0e-2a0b6c1f1b3e',
        icon: 'tick',
        text: 'Includes 2 email accounts',
      },
      {
        _uid: 'e92d4d01-bf4a-4a72-a1aa-6c3e6c8c4f4f',
        icon: 'tick',
        text: 'AI Inbox organization',
      },
      {
        _uid: '0cb4f4f7-3913-4e95-9d2d-854f78d8306a',
        icon: 'tick',
        text: 'Pre-drafted responses',
      },
      {
        _uid: '41df3207-0b9b-4b9e-8a3c-760f0bb63d30',
        icon: 'tick',
        text: 'Daily brief summaries',
      },
      {
        _uid: 'f3e5e246-f63d-4379-91b1-13d735be72f1',
        icon: 'tick',
        text: 'Technical support',
      },
    ],
  },
  {
    _uid: 'cba3fa56-81f1-4f30-8e3d-8e3bb7410e64',
    name: 'Unlimited',
    monthly: { price: '$30/month', note: '' },
    yearly: { price: '$24/month', note: 'Billed anually as $288' },
    features: [
      {
        _uid: '51e2fa34-f3c3-4a36-996e-1ddf84cdba4c',
        icon: 'tick',
        text: 'Everything in Basic',
      },
      {
        _uid: 'a3f09ef0-4d1a-43a1-a969-5ef5bff14ad1',
        icon: 'plus',
        text: 'Includes unlimited email accounts',
      },
    ],
  },
]

export function Pricing({ className }) {
  const [activeTab, setActiveTab] = useState(0)

  return (
    <section
      className={cn(
        'relative mx-auto dr-mt-25 dt:dr-mt-108 dr-w-357 dt:dr-w-604 flex flex-col dr-gap-21 items-center',
        className
      )}
    >
      <h2 className="h2 text-center">Pick a plan</h2>
      <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />

      <div
        className={cn(
          s.card__wrapper,
          'bg-grey dr-rounded-20 dr-p-10 w-full flex flex-col dt:flex-row dr-gap-8 z-[1]'
        )}
      >
        {plans.map((plan) => (
          <PricingCard key={plan._uid} plan={plan} isYearly={activeTab === 0} />
        ))}
      </div>

      <BottomPromo />
    </section>
  )
}
